module.exports = __webpack_public_path__ + "a05c22718d6d26222754fd243edfed5c.svg";